import React from 'react';
import { Outlet, useLocation, matchPath } from 'react-router-dom';
import { Layout } from './Layout';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectUser } from '../../entities/session/model/slice';
import { logout } from '../../entities/session/api/sessionApi';
import { SelectOrganizationModal } from '../SelectOrganizationModal/SelectOrganizationModal';

const ROUTE_META = [
    { path: '/', title: 'Главная', subtitle: 'Обзор проектов, поддержки и материалов сервиса' },
    { path: '/projects', title: 'Проекты', subtitle: 'Расчёт цен и логистики по позициям закупки' },
    { path: '/projects/:projectId', title: 'Проект' },
    { path: '/projects/:projectId/results', title: 'Результаты' },
] as const;

export function AppLayout() {
    const { pathname } = useLocation();
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);

    const meta = ROUTE_META.find((route) => matchPath({ path: route.path, end: true }, pathname));

    return (
        <Layout
            user={user}
            organization={null}
            limits={undefined}
            onLogout={() => dispatch(logout())}
        >
            <Outlet />
            <SelectOrganizationModal />
        </Layout>
    );
}